<template>
  <BaseModal
    :heading="$t('global.message')"
    small
    @close="$emit('close')"
  >
    <Flex direction="column">
      <BaseAlert
        v-if="customersCount"
        :text="$t('customers.message.sending_to', { amount: customersCount }, customersCount)"
        size="s"
        v-test="'message-type-alert'"
      />
      <BaseText>{{ $t('customers.message_type_question') }}</BaseText>
      <div :class="$style.buttons">
        <BaseButtonCard
          :heading="$t('global.email')"
          :description="$t('customers.message.email_description')"
          icon="email"
          chevron
          @click="$emit('select', 'email')"
          v-test="'message-type-email'"
        />
        <BaseButtonCard
          :heading="$t('global.sms_message')"
          :description="$t('customers.message.sms_description')"
          icon="whatsapp"
          chevron
          @click="$emit('select', 'sms')"
          v-test="'message-type-sms'"
        />
        <BaseButtonCard
          v-if="hasMarketingModule && !segmentKey"
          :heading="$t('customers.message.newsletter_template')"
          :description="$t('customers.message.newsletter_template_description')"
          icon="emails"
          chevron
          :disabled="disableNewsletter"
          :routerLink="{ name: 'newsletter-template' }"
          @click="toNewsletter"
          v-test="'message-type-newsletter'"
        />
        <BaseAlert
          v-if="hasMarketingModule && disableNewsletter && !segmentKey"
          :text="$t('customers.newsletter_unavailable')"
          size="s"
          color="warning"
          v-test="'message-type-newsletter-alert'"
        />
      </div>
    </Flex>
  </BaseModal>
</template>

<script
  lang="ts"
  setup
>
import { useUserStore } from '@/stores/user';
import { useMarketingStore } from '../../marketing/store';

const props = defineProps<{
  filters?: any[];
  segmentKey?: string;
}>();
const emit = defineEmits(['select', 'close']);

const totalCount = inject<number>('totalCount');
const selectedCustomers = inject<number[]>('selectedCustomers', []);
const customersCount = computed(
  () => selectedCustomers?.value?.length || totalCount?.value,
);

const { hasFeatureFlag } = useUserStore();
const hasMarketingModule = computed(() => hasFeatureFlag('module-marketing'));
const disableNewsletter = computed(() => !!selectedCustomers?.value?.length);

const { setAllFilters } = useMarketingStore();
const toNewsletter = () => {
  if (props.filters?.length) {
    setAllFilters(props.filters);
  }
  emit('close');
};
</script>

<style
  lang="scss"
  module
>
.buttons {
  display: flex;
  flex-direction: column;
  gap: $spacing;
}
</style>
